var property = {};
export {
  property as __exports
};
//# sourceMappingURL=property.js.map
